import { Container, Text } from '@pixi/react'
import { t } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'

export const voucherTitleTextStyle = new TextStyle({
  align: 'center',
  fontWeight: '900',
  fill: '#FFFFFF',
  dropShadow: true,
  dropShadowColor: 'rgba(94, 93, 93, 0.2)',
  dropShadowBlur: 4, // 模糊程度
  dropShadowAngle: Math.PI / 2, // 正下方 (90度 = π/2 弧度)
  dropShadowDistance: 5, // 距離稍微小一點 (原本你是 5，可以調成 3 比較細緻)
  fontFamily: 'Roboto',
  fontSize: 65,

})
interface IVoucherTitleProps {
  totalRounds: number
}
export const VoucherSelectPopupTitle = (props: IVoucherTitleProps) => {
  return (
    <Container name="VoucherSelectPopupTitle">
      <Text
        text={t('voucher_select_popup_title1')}
        x={0}
        y={-610}
        anchor={[0.5, 0.5]}
        name="title1"
        style={voucherTitleTextStyle}
      />
      <Text
        text={`${props.totalRounds} ${t('voucher_select_popup_title2')}`}
        x={0}
        y={-530}
        anchor={[0.5, 0.5]}
        name="title2"
        style={voucherTitleTextStyle}
      />
    </Container>
  )
}
